/* A reference table.

   Its own file because it is the one kind with a second life on paper: a wide
   table has nowhere to scroll there, so `.handout table` is laid out fixed and
   a handout may take only some of its columns — see lib/handout.ts. On screen
   the wrapper is what scrolls, so a five-column table on a laptop does not push
   the page sideways.

   OWNED BY ITEM 3 OF docs/plan/00-prestavba-2026-08.md. */

import { Head, Notes, T } from "./shared";
import type { TableBlock } from "../lib/types";

export function Table({ b }: { b: TableBlock }) {
  return (
    <>
      <Head b={b} />
      <div className="tablewrap">
        <table>
          <thead><tr>{b.head.map((h, i) => <th key={i}><T value={h} /></th>)}</tr></thead>
          <tbody>
            {b.rows.map((row, i) => (
              <tr key={i}>{row.map((c, j) => <td key={j}><T value={c} /></td>)}</tr>
            ))}
          </tbody>
        </table>
      </div>
      <Notes b={b} />
    </>
  );
}
